module.exports = __webpack_public_path__ + "img/OMART-footer-mobile.2ef36993.svg";